(function (global) {
    'use strict';

    fabric.Image.filters.KMeans = fabric.util.createClass(fabric.Image.filters.BaseFilter, {
        type: 'KMeans',

        threshold: 150,
        fgColor: '#000000',
        bgColor: '#ffffff',

        // Foreground color components
        _rf: 0,
        _gf: 0,
        _bf: 0,
        _af: 0,

        // Background color components
        _rb: 0,
        _gb: 0,
        _bb: 0,
        _ab: 0,

        initialize: function (options) {
            options = options || {};

            this.threshold = options.threshold || 150;
            this.fgColor = options.fgColor || '#000000';
            this.bgColor = options.bgColor || '#ffffff';

            this.setFgColor(this.fgColor);
            this.setBgColor(this.bgColor);
        },

        /**
         * Apply a KMeans algorithm based on a threshold, we use the pixel luminance to determine
         *  if the pixel should be included or not.
         *
         * @param {Object} options
         * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
         */
        applyTo2d: function (options) {
            // Now read and iterate over the pixels
            const imageData = options.imageData;
            const pixels = imageData.data;

            for (var n = 0; n < pixels.length; n += 4) {
                var r = pixels[n];
                var g = pixels[n + 1];
                var b = pixels[n + 2];
                var alpha = pixels[n + 3];

                // Calculate the pixel luminance
                // http://stackoverflow.com/questions/596216/formula-to-determine-brightness-of-rgb-color
                var luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

                // If the luminance is over the threshold, this pixel should be removed (background color)
                if (luminance > this.threshold || alpha === 0) {
                    pixels[n] = this._rb;
                    pixels[n + 1] = this._gb;
                    pixels[n + 2] = this._bb;
                    pixels[n + 3] = this._ab;
                }
                // Otherwise make it the foreground color
                else {
                    pixels[n] = this._rf;
                    pixels[n + 1] = this._gf;
                    pixels[n + 2] = this._bf;
                    pixels[n + 3] = this._af;
                }
            }
        },

        setFgColor: function (color) {
            const fgColorArray = new fabric.Color(color).getSource();
            this._rf = fgColorArray[0];
            this._gf = fgColorArray[1];
            this._bf = fgColorArray[2];
            this._af = fgColorArray[3] * 255;
        },

        setBgColor: function (color) {
            const bgColorArray = new fabric.Color(color).getSource();
            this._rb = bgColorArray[0];
            this._gb = bgColorArray[1];
            this._bb = bgColorArray[2];
            this._ab = bgColorArray[3] * 255;
        }
    });

    fabric.Image.filters.KMeans.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})(typeof exports !== 'undefined' ? exports : this);
